/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import AmplifyApiService from '../../services/AmplifyApiService';
import IAmplifyApiConfig from '../../shared/interfaces/IAmplifyApiConfig';
//
const amplifyApiService = new AmplifyApiService();

const BASE_PATH = 'energy-emissions';

export type IEnergyEmission = {
  id: number;
  companyId?: number;
  name: string;
  year?: number;
  emissionFactor: number;
  source: string;
  comment?: string;
  countryCode?: string;
};

export type CreateEnergyEmissionProps = {
  name: string;
  source: string;
  emissionFactor: number;
  comment?: string;
};

export type CreateEnergyEmissionResponse = {
  id: number;
};

// Hook for getting energy emissions that belong user's company
export const useListEnergyEmissions = (
  options: UseQueryOptions<IEnergyEmission[], Error> = {},
): UseQueryResult<IEnergyEmission[]> => {
  const amplifyApiConfig: IAmplifyApiConfig = {
    apiName: 'PacificApi',
    path: BASE_PATH,
  };

  const query = useQuery<IEnergyEmission[], Error>({
    queryKey: [BASE_PATH],
    queryFn: async (): Promise<IEnergyEmission[]> => {
      const response = await amplifyApiService.get<IEnergyEmission[]>(amplifyApiConfig);

      return response;
    },
    ...options,
  });

  return query;
};

// Hook for creating custom energy emission
export const useCreateEnergyEmission = (
  options: UseMutationOptions<CreateEnergyEmissionResponse, Error, CreateEnergyEmissionProps> = {},
): UseMutationResult<CreateEnergyEmissionResponse, Error, CreateEnergyEmissionProps> => {
  const mutation = useMutation<CreateEnergyEmissionResponse, Error, CreateEnergyEmissionProps>({
    mutationFn: async (body: CreateEnergyEmissionProps) => {
      const amplifyApiConfig: IAmplifyApiConfig = {
        apiName: 'PacificApi',
        path: BASE_PATH,
        options: { body },
      };

      return await amplifyApiService.post<CreateEnergyEmissionProps, CreateEnergyEmissionResponse>(
        amplifyApiConfig,
      );
    },
    ...options,
  });

  return mutation;
};
